import database, { membersDataRef, firebase } from '../../firebase/config';
import * as actions from './actionTypes';

export const getUserQuizScore = (uid, quizId) => {
    return dispatch => {
        // console.log("FETCHING USERS SCORES:");
        membersDataRef.doc(uid).get()
            .then(docSnapshot => {
                let memberData = docSnapshot.data();
                // console.log("IS THERE MEMBERDATA:");
                // console.log(memberData);

                if (memberData && memberData.quizScores && memberData.totalQuizScore) {
                    let currentQuizScore = memberData.quizScores[quizId];
                    dispatch(setUserQuizScores(memberData.quizScores, memberData.totalQuizScore, currentQuizScore));
                } else {
                    dispatch(setUserQuizScores({}, 0, 0));
                }
            })
            .catch(err => console.log(err));
    }
};

export const startSubmitUserQuizScore = (uid, score, quizId) => {
    return dispatch => {
        if (score === undefined || isNaN(score)) return;
        // console.log("STARTING TO SUBMIT USER SCORE FOR:");
        // console.log("USER ID: ", uid);
        // console.log("QUIZ ID: ", quizId);
        // console.log("SCORE: ", score);
        // score = score / 10;
        let scoresObject;
        const transaction = database.runTransaction(t => {
            return t.get(membersDataRef.doc(uid))
                .then(docSnapshot => {
                    let data = docSnapshot.data();
                    let newScore = 0;
                    if (data && !data.quizScores[quizId]) {
                        newScore = Number(data.totalQuizScore) + Number(score);
                        scoresObject = data.quizScores;
                        scoresObject[quizId] = score;
                    }
                    else {
                        newScore = score;
                        scoresObject = {
                            [quizId]: score,
                        }
                    }
                    t.set(membersDataRef.doc(uid), {
                            totalQuizScore: newScore,
                            quizScores: scoresObject,
                        }, { merge: true }
                    );
                });
        })
            .then(res => {
                // console.log("Quiz score update success, ", res);
                dispatch(setUserQuizScores(scoresObject));
            })
            .catch(err => {
                console.log("Quiz score update failed:", err);
            });

    }
};

export const setUserQuizScores = (scoresObject, totalQuizScore, currentQuizScore) => ({
   type: actions.SET_USER_QUIZ_SCORES,
    quizScores: scoresObject,
    totalQuizScore,
    currentQuizScore,
});

export const setCurrentQuizScore = (scoresObject, quizId) => ({
    type: actions.SET_USER_CURRENT_QUIZ,
    currentQuizScore: scoresObject[quizId],
});

export const setUserCompletedPractice = (completedPractice) => ({
    type: actions.SET_USER_COMPLETED_PRACTICE,
    completedPractice: completedPractice || {},
});

/** Save a practice problem as completed to Firebase (membersData). Merges into completedPractice[categoryKey] array. */
// A dated record of every practice question finished - including ones done again.
// completedPractice (below) is a plain list with no dates, and it never fires twice
// for the same question, so the This month board (content-app/lib/monthServer.js)
// could not tell what was done this month. One write per question per visit.
const practiceLogged = new Set();
export const logPracticeDone = (uid, categoryKey, problemId) => {
    return () => {
        if (!uid || !categoryKey || !problemId) return;
        const key = `${uid}|${categoryKey}|${problemId}`;
        if (practiceLogged.has(key)) return;
        practiceLogged.add(key);
        // Returned so the trainer can wait for the stamp before asking the ladder for the new total (15 Oct 2026).
        return membersDataRef.doc(uid)
            .set({ practiceLog: { [categoryKey]: { [problemId]: firebase.firestore.FieldValue.serverTimestamp() } } }, { merge: true })
            // In a Game Plan panel: tell the page, so the ladder and the "done" count update.
            .then(() => { try { if (window.self !== window.top) window.parent.postMessage({ type: 'bc-month-result', practice: String(problemId) }, '*'); } catch (_) {} })
            .catch((err) => { practiceLogged.delete(key); console.error('logPracticeDone failed:', err); });
    };
};

// Game Plan "Counting" drills. Since 20 Oct 2026 (Paul): 10 hand shapes right = 3, 10 opponent shapes right (opp10) = 3.
// Before that (20 Sep 2026): 10 hand shapes in a row = 3 points, a Count real
// hands deal at level 1 / 2 / 3 = 1 / 2 / 3 points, each ONCE A DAY. Stamped under
// membersData.practiceLog.daily.<UTC date>.<key> (key: shape10 | opp10 | count1 | count2 | count3) so the
// ladder's existing practiceLog query finds it (content-app/lib/monthServer.js).
// The drills' "day" runs from 9am Sydney time (daylight saving included). KEEP THE SAME as drillDay in
// content-app/lib/thisMonth.js - the ladder decides the day from the stamp, this only files it.
const drillDay = (ms = Date.now()) => {
    const p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date(ms)).forEach((x) => { p[x.type] = Number(x.value); });
    const midnight = Date.UTC(p.year, p.month - 1, p.day) - (p.hour < 9 ? 86400000 : 0);
    return new Date(midnight).toISOString().slice(0, 10);
};
const dailyLogged = new Set();
// Resolves { fresh: true } when this earned today's points, { fresh: false } when they were already earned
// today (the Treadmill shows "+3 points" or "already got today's points" - Paul, 20 Oct 2026).
export const logDailyDrill = (uid, key) => {
    return () => {
        if (!uid || !/^(shape10|opp10|sudoku5|count[123])$/.test(String(key))) return Promise.resolve(null);
        const day = drillDay();
        const k = `${uid}|${day}|${key}`;
        if (dailyLogged.has(k)) return Promise.resolve({ fresh: false });
        dailyLogged.add(k);
        // NO read first: the membersData rules only allow reads that look like a valid write, so a get() here is
        // refused and nothing was saved at all (20-21 Oct 2026). Write the stamp as before - one score per drill per
        // day, so a later stamp on the same day changes nothing - and remember "already earned" in this browser.
        const seenKey = `bcDrill|${k}`;
        let fresh = true;
        try { fresh = !window.localStorage.getItem(seenKey); } catch (_) {}
        return membersDataRef.doc(uid)
            .set({ practiceLog: { daily: { [day]: { [key]: firebase.firestore.FieldValue.serverTimestamp() } } } }, { merge: true })
            .then(() => { try { window.localStorage.setItem(seenKey, '1'); } catch (_) {} return { fresh }; })
            // `drill` lets the Game Plan page say "Congratulations, +N points" in the panel.
            .then((res) => { try { if (window.self !== window.top) window.parent.postMessage({ type: 'bc-month-result', drill: key }, '*'); } catch (_) {} return res; })
            .catch((err) => { dailyLogged.delete(k); console.error('logDailyDrill failed:', err); return null; });
    };
};

export const savePracticeCompletion = (uid, categoryKey, problemId) => {
    return (dispatch, getState) => {
        if (!uid || !categoryKey || !problemId) return;
        const docRef = membersDataRef.doc(uid);
        docRef.get()
            .then((doc) => {
                const data = doc.data() || {};
                const existing = data.completedPractice || {};
                const list = Array.isArray(existing[categoryKey]) ? [...existing[categoryKey]] : [];
                if (list.includes(problemId)) return;
                list.push(problemId);
                const completedPractice = { ...existing, [categoryKey]: list };
                return docRef.set({ completedPractice }, { merge: true }).then(() => completedPractice);
            })
            .then((completedPractice) => {
                if (completedPractice) dispatch(setUserCompletedPractice(completedPractice));
            })
            .catch((err) => console.error('savePracticeCompletion failed:', err));
    };
};